import type { Class, Ref } from '@hcengineering/core'
import type { Employee } from '@hcengineering/contact'
import { plugin, type Asset, type IntlString, type Plugin } from '@hcengineering/platform'
import type { Preference } from '@hcengineering/preference'
import type { AnyComponent } from '@hcengineering/ui'
import type { Application } from '@hcengineering/workbench'

export type ActivityKind = 'task-created' | 'task-comment' | 'post-created' | 'image-uploaded' | 'card-created' | 'card-comment' | 'card-uploaded' | 'meeting-joined'

export interface CalendarConfig {
  id: string
  name: string
  activities: ActivityKind[]
  memberId?: Ref<Employee>
  memberIds?: Ref<Employee>[]
  allMembers?: boolean
  projectId?: string
  componentId?: string
  milestoneId?: string
  taskId?: string
  thresholds: [number, number, number, number]
  color: string
}

export interface StatisticsPage extends Preference {
  name: string
  timezone: string
  year: number
  calendars: CalendarConfig[]
}

export interface Contribution {
  key: string
  kind: ActivityKind
  createdAt: number
  sourceId: string
  sourceClass?: string
  cardId?: string
  label: string
  url?: string
  taskId?: string
  projectId?: string
  componentId?: string
  milestoneId?: string
}

export interface ActivityLoadOptions {
  from: number
  to: number
  maxRecords?: number
  signal?: AbortSignal
  onProgress?: (progress: { loaded: number, message: string }) => void
}

export interface ActivityLoadResult {
  contributions: Contribution[]
  memberName?: string
  complete: boolean
  warnings: string[]
}

export const statisticsId = 'statistics' as Plugin

export default plugin(statisticsId, {
  class: { StatisticsPage: '' as Ref<Class<StatisticsPage>> },
  app: { Statistics: '' as Ref<Application> },
  component: { Statistics: '' as AnyComponent },
  icon: { Statistics: '' as Asset },
  string: { Statistics: '' as IntlString }
})
